var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.057 7.18066C21.0663 7.39186 21.0663 7.59346 21.0663 7.80466C21.0755 14.2079 16.3711 21.5999 7.76781 21.5999C5.23036 21.5999 2.73921 20.8415 0.599976 19.4207C0.970406 19.4687 1.34084 19.4879 1.71127 19.4879C3.81346 19.4879 5.86009 18.7583 7.51777 17.4047C5.51744 17.3663 3.7579 16.0127 3.14669 14.0351C3.8505 14.1791 4.57284 14.1503 5.25814 13.9487C3.08186 13.5071 1.51679 11.5199 1.50753 9.20626C1.50753 9.18706 1.50753 9.16786 1.50753 9.14866C2.15578 9.52306 2.88738 9.73426 3.62825 9.75346C1.58162 8.33266 0.942624 5.50065 2.18357 3.28304C4.56358 6.31665 8.06415 8.15026 11.824 8.35186C11.4443 6.67185 11.9629 4.90545 13.1761 3.71505C15.056 1.88144 18.0195 1.97744 19.7975 3.92625C20.844 3.71505 21.8534 3.31184 22.7702 2.74544C22.4183 3.86865 21.6867 4.81905 20.7144 5.42385C21.6404 5.30865 22.548 5.04945 23.4 4.66545C22.7702 5.64465 21.9738 6.48945 21.057 7.18066Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.55fc172cdad67be12295e7ad935bc65f.svg";
export { ForwardRef as ReactComponent };